export const mobileScreenSize = '500px'
export const contentWrapperTop = '100px'
export const headerHeight = 'var(--header-height)'
// helpers
export const addBackgroundImage = ($element, imagePath) =>
  $element.style = `background-image:url(${imagePath})`